import React, { useState } from "react";
import "./productReview.scss";
// import Reviews from "../../../components/reviews/Reviews";
import {
  Box,
  Button,
  Grid,
  LinearProgress,
  Rating,
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  useMediaQuery,
} from "@mui/material";
// icon
import StarRoundedIcon from "@mui/icons-material/StarRounded";
import CloseIcon from "@mui/icons-material/Close";
import Reviews from "../../../components/reviews/Reviews";
import productRatingStore from "../../../store/productRatingStore";
import ReviewSkeleton from "../../../components/reviews/ReviewSkeleton";
import userStore from "../../../store/userStore";
import { useEffect } from "react";

const ProductReview = ({
  productID,
  totalReview,
  setTotalReview,
  averageRating,
  setAverageRating,
  ratingLoading,
  setRatingLoading,
}) => {
  const ProductRatingStore = productRatingStore();
  const UserStore = userStore();
  const maxWidth_600 = useMediaQuery("(max-width:600px)");

  const [open, setOpen] = useState(false);
  const [productReview, setProductReview] = useState([]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [particularRating, setParticularRating] = useState([
    { id: 1, name: "5 Star", value: 0, reviewCount: "0" },
    { id: 2, name: "4 Star", value: 0, reviewCount: "0" },
    { id: 3, name: "3 Star", value: 0, reviewCount: "0" },
    { id: 4, name: "2 Star", value: 0, reviewCount: "0" },
    { id: 5, name: "1 Star", value: 0, reviewCount: "0" },
  ]);

  useEffect(() => {
    if (ProductRatingStore.allReview) {
      setRatingLoading(true);

      let totalR = 0;
      let averageR = 0;

      let fiveStarR = 0;
      let fourStarR = 0;
      let threeStarR = 0;
      let twoStarR = 0;
      let oneStarR = 0;

      let productRatingReview = [];

      ProductRatingStore.allReview
        .sort((a, b) => {
          return new Date(b.created_at) - new Date(a.created_at);
        })
        .map((item) => {
          if (productID === item.productID) {
            totalR++;
            averageR = averageR + item.rating;
            productRatingReview = [...productRatingReview, item];
            if (item.rating === 5) {
              fiveStarR++;
            }
            if (item.rating === 4) {
              fourStarR++;
            }
            if (item.rating === 3) {
              threeStarR++;
            }
            if (item.rating === 2) {
              twoStarR++;
            }
            if (item.rating === 1) {
              oneStarR++;
            }
          }
        });
      setProductReview(productRatingReview);
      setTotalReview(totalR);
      if (totalR !== 0) {
        setAverageRating(averageR / totalR);

        const fiveStarB = (fiveStarR / totalR) * 100;
        const fourStarB = (fourStarR / totalR) * 100;
        const threeStarB = (threeStarR / totalR) * 100;
        const twoStarB = (twoStarR / totalR) * 100;
        const oneStarB = (oneStarR / totalR) * 100;

        setParticularRating([
          { id: 1, name: "5 Star", value: fiveStarB, reviewCount: fiveStarR },
          { id: 2, name: "4 Star", value: fourStarB, reviewCount: fourStarR },
          { id: 3, name: "3 Star", value: threeStarB, reviewCount: threeStarR },
          { id: 4, name: "2 Star", value: twoStarB, reviewCount: twoStarR },
          { id: 5, name: "1 Star", value: oneStarB, reviewCount: oneStarR },
        ]);
      } else {
        setAverageRating(0);
        setParticularRating([
          { id: 1, name: "5 Star", value: 0, reviewCount: "0" },
          { id: 2, name: "4 Star", value: 0, reviewCount: "0" },
          { id: 3, name: "3 Star", value: 0, reviewCount: "0" },
          { id: 4, name: "2 Star", value: 0, reviewCount: "0" },
          { id: 5, name: "1 Star", value: 0, reviewCount: "0" },
        ]);
      }
      setRatingLoading(false);
    }
    setRatingLoading(false);
  }, [productID, ProductRatingStore.allReview]);

  return (
    <div className="productReview">
      <p className="rating-title">Ratings</p>
      <Grid container className="reviews">
        <Grid item container className="overview">
          <Grid
            item
            xs={12}
            md={6}
            sx={{ border: "1px solid hsl(220, 10%, 94%)" }}
            className="average-rating"
          >
            <h3>Average rating</h3>
            <h1>{averageRating.toFixed(1)}/5</h1>
            <Rating
              name="read-only"
              value={parseInt(averageRating.toFixed(1))}
              readOnly
              precision={0.1}
              sx={{ fontSize: "23px" }}
              icon={<StarRoundedIcon fontSize="inherit" />}
              emptyIcon={<StarRoundedIcon fontSize="inherit" />}
            />
            <p>
              (
              {totalReview > 999
                ? (totalReview / 1000).toFixed(2) + "k"
                : totalReview}{" "}
              reviews)
            </p>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            sx={{ border: "1px solid hsl(220, 10%, 94%)" }}
            className="particular-rating"
          >
            {particularRating &&
              particularRating.map((item) => (
                <Box className="single-rating" key={item.id}>
                  <p className="star">{item.name}</p>
                  <LinearProgress
                    variant="determinate"
                    value={item.value}
                    className="linear-progress"
                  />
                  <p>
                    {item.reviewCount > 999
                      ? (item.reviewCount / 1000).toFixed(2) + "k"
                      : item.reviewCount}
                  </p>
                </Box>
              ))}
          </Grid>
          {/* <Grid
            item
            xs={12}
            md={4}
            sx={{ border: "1px solid hsl(220, 10%, 94%)" }}
            className="write-your-review"
          >
            <Button
              variant="contained"
              className="btn"
              startIcon={<EditIcon />}
            >
              Write your review
            </Button>
          </Grid> */}
        </Grid>
        <Grid item container className="reviews-container">
          <div className="customer-ratings-title">Customer Rating</div>
          {ProductRatingStore.isLoadingAll || UserStore.isLoading ? (
            <ReviewSkeleton />
          ) : totalReview !== 0 ? (
            <>
              {productReview
                .slice(0, 4)
                .reverse()
                .map((item) => {
                  if (productID === item.productID) {
                    return <Reviews key={item._id} item={item} />;
                  }
                })}
              <Dialog
                fullScreen={maxWidth_600 ? true : false}
                open={open}
                onClose={handleClose}
                fullWidth
                maxWidth="lg"
                // TransitionComponent={Transition}
              >
                <AppBar sx={{ position: "sticky" }}>
                  <Toolbar>
                    <IconButton
                      edge="start"
                      color="inherit"
                      onClick={handleClose}
                      aria-label="close"
                    >
                      <CloseIcon />
                    </IconButton>
                  </Toolbar>
                </AppBar>
                {productReview
                  .slice(0)
                  .reverse()
                  .map((item) => {
                    if (productID === item.productID) {
                      return <Reviews key={item._id} item={item} />;
                    }
                  })}
              </Dialog>
              {totalReview > 4 && (
                <Button
                  sx={{ m: 1, color: "var(--blackColor)" }}
                  onClick={handleClickOpen}
                >
                  View All
                </Button>
              )}
            </>
          ) : (
            <div className="no-customer-rating">
              <p>No Customer Rating</p>
            </div>
          )}
        </Grid>
      </Grid>
    </div>
  );
};

export default ProductReview;
